import { NextRouter } from 'next/router';

export const canonicalUrl = (router: NextRouter, customPath?: string) => {
  return customPath ? customPath : process.env.SITE_URL + router.asPath;
};
